<template>
    <div style="flex: 1; overflow: hidden;" @touchmove.stop="() => { }">
        <InfinityScroll :handle-next-page="handleNextPage" :is-enable-next-page-handle="isEnableNextPageHandle" :refresh-action="refresh" style="height: 100%;">
            <div>
                <template v-if="isShowTab">
                    <div v-if="mode === MODAL_MODE.DONG" style="margin-top: 8px; padding: 0 12px;">
                        <div style="font-weight: 700; font-size: 12px;">활동지역</div>
                        <div style="font-weight: 500; font-size: 12px; line-height: 20px; display: flex;align-items: center; gap: 4px; color: #606060;">{{ selectDong.dong }}<span class="circle_s"></span>이 장소를 {{ selectDong.member_cnt | comma }}명이 이용했습니다.</div>
                    </div>
                    <div class="hide_scroll" style="flex-shrink: 0; padding: 0 12px; display: flex; overflow-x: scroll; gap: 8px; margin-top: 12px;">
                        <div @click="setTab(each.tab)" :class="each.tab === tab ? 'active' : 'un_active'" v-for="each, i in tabList" :key="i" style="padding: 8px 12px; border-radius: 12px; flex-shrink: 0; text-align: center;">
                            <div style="font-weight: 700; line-height: 20px; font-size: 12px;">{{ each.title }}</div>
                            <div style="font-weight: 500; font-size: 10px; line-height: 20px;">{{ each.contents }}</div>
                        </div>
                    </div>
                </template>
                <div style="position: sticky; z-index: 10; top:0; background-color: #fff; padding-top: 12px; ">
                    <div style="position: relative; padding: 0 12px;">
                        <MercenarySearchInput :enter="enter" :searchWord="searchWord" :setSearchWord="setSearchWord" :placeholder="'이름, 포지션, 나이대 등 검색'"></MercenarySearchInput>
                    </div>
                    <div style="display: flex; padding: 0 24px; justify-content: space-between; margin-top: 20px; border-bottom: 1px solid #ebebeb; padding-bottom: 10px;">
                        <div @click="setSubTabList(each)" :class="subTab === each.title ? 'sub_active' : ''" class="tab_list" v-for="each, i in subTabList" :key="i + 'sub'">{{ each.title }} {{ each.cnt }}명</div>
                    </div>
                </div>
                <div style="padding: 0 12px;">
                    <div style="margin-top: 20px; font-weight: 700; margin-bottom: 20px;">이 위치에서 활동중인 사람</div>
                    <div v-for="each, i in activeMemberList" :key="i" :style="{ paddingTop: i !== 0 ? '12px' : '' }" style="padding-bottom: 12px; border-bottom: 1px solid #ebebeb;">
                        <div style="display: flex; justify-content: space-between; ">
                            <div style="display: flex; align-items: center; gap: 8px;">
                                <div @click.stop="$Util.showProfile(each.member_idx, each.member_type, '', each.is_coach)">
                                    <ProfileImage style="width: 40px;" :imagePath="each.image_path"></ProfileImage>
                                </div>
                                <div style="display: flex; align-items: center; gap: 4px;">
                                    <div style="font-weight: 700; font-size: 12px;">{{ each.nic_name }}</div>
                                    <div style="font-weight: 900; font-size: 11px; color: #808080;">{{ $Util.position_display_str(each.member_type, each.position, each.is_coach) }}</div>
                                </div>
                            </div>
                            <div v-if="btnAction" @click="btnAction(each)" style="width: 90px; height: 36px; line-height: 36px; text-align: center; border-radius: 12px; background-color: #f5f5f5; color: var(--color-main); font-size: 12px; font-weight: 500;">{{ btnName }}</div>
                            <div v-else @click="setIsOpenInviteScheduleModal(each)" style="width: 90px; height: 36px; line-height: 36px; text-align: center; border-radius: 12px; background-color: #f5f5f5; color: var(--color-main); font-size: 12px; font-weight: 500;">같이 축구하기</div>
                        </div>
                        <div style="display: flex; gap: 6px; margin-top: 8px;">
                            <div style="display: flex; align-items: center; font-weight: 700; font-size: 12px; gap: 4px;">
                                <div style="width: 4px; height: 4px; background-color: #201f03; border-radius: 50%;"></div>
                                <div style="white-space: nowrap; ">{{ each.age_range }}</div>
                            </div>
                            <div style="display: flex; align-items: center; font-weight: 700; font-size: 12px; gap: 4px;">
                                <div style="width: 4px; height: 4px; background-color: #201f03; border-radius: 50%;"></div>
                                <div style="white-space: nowrap; ">{{ each.height ? each.height + 'cm' : '설정하지 않음' }}</div>
                            </div>
                            <div style="display: flex; align-items: center; font-weight: 700; font-size: 12px; gap: 4px; overflow:hidden; flex:1;">
                                <div style="width: 4px; height: 4px; background-color: #201f03; border-radius: 50%;"></div>
                                <div style="overflow:hidden;text-overflow: ellipsis; white-space: nowrap; ">{{ each.playstyle ? each.playstyle : '설정하지 않음' }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </InfinityScroll>
        <InviteMySchedule :selectDong="selectDong" :memberInfo="memberInfo" :region_result="region_result" :mode="mode" :isOpen="isOpenInviteScheduleModal" :closeCompleteAction="closeInviteScheduleModal"></InviteMySchedule>
    </div>
</template>

<script>
import { MODAL_MODE } from "@/Constants";
import InfinityScroll from '@/components/common/InfinityScroll';
import InviteMySchedule from '@/components/common/InviteMySchedule';
import MercenarySearchInput from '@/components/common/MercenarySearchInput';
import ProfileImage from '@/components/common/ProfileImage';

const SUB_TAB_LIST = {
    WHOLE: '전체',
    MEMBER: '멤버',
    RECENT: '최근 본 사람',
    WITH_MERC: '함께한 용병'
}

const SUB_TAB_KEY = {
    ALL: 'all',
    RECENT: 'recent',
    TOGETGHER: 'together',
    MEMBER: 'member'
}

export default {
    name: 'ModalFindMercenary',
    components: { InfinityScroll, MercenarySearchInput, ProfileImage, InviteMySchedule },
    props: {
        setTab: {
            type: Function,
            default: () => { }
        },
        tab: {
            type: String,
            default: ''
        },
        tabList: {
            type: Array,
            default: () => { }
        },
        selectDong: {
            type: Object,
            default: () => { }
        },
        mode: {
            type: String,
            default: () => { }
        },
        region_result: {
            type: Object,
            default: () => { }
        },
        isShowTab: {
            type: Boolean,
            default: true
        },
        btnName: {
            type: String,
            default: ''
        },
        btnAction: {
            type: Function,
            default: null
        }
    },
    data() {
        return {
            isEnableNextPageHandle: true,
            page: 1,
            wholeCnt: 35,
            memberCnt: 1,
            recentCnt: 4,
            withMercCnt: 2,
            subTabList: [
                { title: '전체', cnt: 0, key: 'all' },
                { title: '멤버', cnt: 0, key: 'member' },
                { title: '최근 본 사람', cnt: 0, key: 'recent' },
                { title: '함께한 용병', cnt: 0, key: 'together' },
            ],
            subTab: SUB_TAB_LIST.WHOLE,
            SUB_TAB_LIST: SUB_TAB_LIST,
            MODAL_MODE: MODAL_MODE,
            subTabKey: SUB_TAB_KEY.ALL,
            SUB_TAB_KEY: SUB_TAB_KEY,
            activeMemberList: [],
            isOpenInviteScheduleModal: false,
            memberInfo: {},
            searchWord: ''
        }
    },
    methods: {
        setSearchWord(result) {
            this.searchWord = result
        },
        enter(e) {
            this.searchWord = e.target.value
            if (e.keyCode === 13) {
                this.getMemberList(true)
            }
        },
        setIsOpenInviteScheduleModal(member_info) {
            this.isOpenInviteScheduleModal = true;
            this.memberInfo = member_info
        },
        closeInviteScheduleModal() {
            this.isOpenInviteScheduleModal = false
        },
        handleNextPage() {
            this.page++
            this.getMemberList()
        },
        initializeSubTabList() {
            this.subTabList = [
                { title: '전체', cnt: this.wholeCnt, key: 'all' },
                { title: '멤버', cnt: this.memberCnt, key: 'member' },
                { title: '최근 본 사람', cnt: this.recentCnt, key: 'recent' },
                { title: '함께한 용병', cnt: this.withMercCnt, key: 'together' },
            ]
        },
        refresh() {
            this.page = 1
            this.activeMemberList = []
            this.getMemberList()
        },
        setSubTabList(item) {
            this.subTab = item.title
            this.subTabKey = item.key
            this.activeMemberList = []
            this.page = 1
            this.getMemberList()
        },
        async getMemberList(isSearch) {
            if (isSearch) {
                this.page = 1
                this.activeMemberList = []
            }
            this.isEnableNextPageHandle = false
            const parameters = {}
            parameters.page = this.page;
            parameters.type = this.subTabKey
            parameters.region_code = this.mode === MODAL_MODE.CURRENT_LOC ? this.region_result.region_code.slice(0, 6) : this.selectDong.code.slice(0, 8);
            parameters.searchWord = this.searchWord === '' ? null : this.searchWord

            const res = await this.$Axios.get('/api/member/region/list', { params: parameters })
            const result = res.data.members

            if (result.length > 0) {
                this.isEnableNextPageHandle = true;
                this.activeMemberList = [...this.activeMemberList, ...result];
            }
        },
        async getSummary() {
            const parameters = {}
            parameters.region_code = this.mode === MODAL_MODE.CURRENT_LOC ? this.region_result.region_code.slice(0, 6) : this.selectDong.code.slice(0, 8);

            const res = await this.$Axios.get('/api/member/region/list/statis', { params: parameters })

            this.wholeCnt = res.data.all_cnt
            this.memberCnt = res.data.member_cnt
            this.recentCnt = res.data.recent_cnt
            this.withMercCnt = res.data.together_cnt

            this.initializeSubTabList()
        }
    },
    created() {
        this.getMemberList()
        this.getSummary()
    }

}
</script>

<style scoped>
.circle_s {
    display: inline-block;
    width: 2px;
    height: 2px;
    background-color: #606060;
    border-radius: 50%;
}

.active {
    background-color: #210F03;
    color: #fff;
}

.active div {
    color: #fff;
}

.un_active {
    background-color: #f5f5f5;
}

.un_active>div:nth-child(2) {
    color: #606060;
}

.tab_list {
    font-weight: 700;
    font-size: 12px;
    position: relative;
}

.sub_active::after {
    content: '';
    height: 2px;
    background-color: #210F03;
    position: absolute;
    width: calc(100% + 20px);
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
}
</style>